import React from 'react';
import { Box, Typography } from '@material-ui/core';

import { formatSessionDateTime, formatSessionPlace } from '../../../lib/helpers/assessment-session.helpers';

// Derived, not restated: the display fields this card reads, so the RSVP query
// can select exactly these and a full upcoming-list row still satisfies it.
type IRsvpSessionDetailsSession = Pick<
  IPlayerAttendanceSession,
  'date' | 'start' | 'duration' | 'location' | 'area' | 'address'
>;

interface IRsvpSessionDetailsProps {
  session: IRsvpSessionDetailsSession;
}

// The ice time an RSVP is about, rendered above the response buttons so the
// parent can see which one they're answering for before they tap.
export const RsvpSessionDetails: React.FC<IRsvpSessionDetailsProps> = ({ session }) => {
  const place = formatSessionPlace(session);

  return (
    <Box
      style={{
        background: '#f9fafb',
        border: '1px solid #e5e7eb',
        borderRadius: 8,
        padding: '12px 16px',
        textAlign: 'left',
      }}
    >
      <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
        {formatSessionDateTime(session.date, session.start, session.duration)}
      </Typography>
      {place && (
        <Typography variant="body2" color="textSecondary">{place}</Typography>
      )}
      {session.address && (
        <Typography variant="body2" color="textSecondary">{session.address}</Typography>
      )}
    </Box>
  );
};
